<div id="list-claims" *ngIf="templateView==1">
    <h2 class="font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.LISTING_CLAIMS" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                </div>
            </div>
            <div class="form-group row mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="filterPolicyForm"
                    (ngSubmit)="submitFilterPolicy(loadingModal)"
                    >
                        <div class="row mb-3">

                            <div class="col-md-3 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "CLAIMS.BY_CLAIM_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'CLAIMS.BY_CLAIM_NUM' | translate }}" formControlName="inputNroReclamo" name="inputNroReclamo">
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.BY_POLICY_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputNroDePoliza" name="inputNroDePoliza">
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="-sr-only">{{ "INPUT.YEAR" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo">
                                                <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                                <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="-sr-only">{{ "INPUT.MONTH" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes">
                                                <option value="">{{ "INPUT.MONTH" | translate }}</option>
                                                <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INSURANCE.CATEGORY" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputRamo" name="inputRamo" (change)="changeRamo($event)">
                                        <option value="">{{ "INSURANCE.CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of ramos | async" value="{{item.IdRamo}}">{{item.Ramo}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INSURANCE.SUB_CATEGORY" | translate }}</label>
                                    <select class="form-control" formControlName="inputSubRamo" name="inputSubRamo" ng-disabled="!IdRamo">
                                        <option value="">{{ "INSURANCE.SUB_CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of subramos | async" value="{{item.IdSubRamo}}">{{item.SubRamo}}</option>
                                    </select>
                                </div>
                            </div>
                        
                            <div class="col-md-3 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.FIRSTNAME" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.FIRSTNAME' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                </div>
                            </div>

                            <div class="col-md-2 mt-2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.PERSONID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.PERSONID' | translate }}" formControlName="inputIdentificacion" name="inputIdentificacion">
                                </div>
                            </div>

                            <div class="col-md-2 mt-2"  *ngIf="config.IdMostrarTablilla==1">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.CARID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.CARID' | translate }}" formControlName="inputPlaca" name="inputPlaca">
                                </div>
                            </div>

                            <div class="col-md-2 mt-2" *ngIf="permissionMenu.VerGrupoEconomico == 1">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.ECONOMICGROUP" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.ECONOMICGROUP' | translate }}" formControlName="inputGrupoEconomico" name="inputGrupoEconomico">
                                </div>
                            </div>

                            <div class="col-md-3 mt-2" *ngIf="permissionMenu.VerCompania == 1">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INPUT.COMPANIES" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputIdCompania" name="inputIdCompania">
                                        <option value="">{{ "INPUT.COMPANIES" | translate }}</option>
                                        <option *ngFor="let item of companies | async" value="{{item.IdCompania}}">{{item.Compania}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-12 mt-5 ">
                                <div class="form-group mb-0 mt-3 text-right">
                                    <button type="submit" class="btn btn-red text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b my-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th width="25%" class="text-light">
                            {{ "INSURANCE.INSURED" | translate }}
                        <th class="text-light">
                            {{ "INSURANCE.SUB_CATEGORY" | translate }}
                        </th>
                        <th class="text-light" *ngIf="permissionMenu.VerCompania == 1">
                            {{ "INSURANCE.COMPANY" | translate }}
                        </th>
                        <th>
                            {{ "CLAIMS.NUM_CLAIM" | translate }}
                        </th> 
                        <th>
                            {{ "INSURANCE.NUM_POLICY" | translate }}
                        </th> 
                        <th width="5%">
                            {{ "INSURANCE.START_DATE" | translate }}
                        </th>
                        <th width="5%">
                            {{ "INSURANCE.DUE_DATE" | translate }}
                        </th>
                        <th *ngIf="showComapnyName">
                            {{ "INSURANCE.COMPANY" | translate }}
                        </th>
                        <th width="5%" *ngIf="permissionMenu.VerComision == 1">
                            {{ "INPUT.SALESCOMISSION" | translate }}
                        </th>
                        <th width="5%" *ngIf="permissionMenu.VerComisionAgente == 1">
                            {{ "INPUT.AGENTCOMISSION" | translate }}
                        </th>
                        <th>{{"INSURANCE.STATUS" | translate }}</th>
                        <th colspan="2" width="10%">{{ "INSURANCE.OPTIONS" | translate }}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let claim of listClaimsService.items$ | async; let i = index">
                            <td>{{ claim.Asegurado }}</td>
                            <td>{{ claim.SubRamo }}</td>
                            <td *ngIf="permissionMenu.VerCompania == 1"
                            >{{ claim.Aseguradora }}</td>
                            <td>{{ claim.NroReclamo }}</td>
                            <td>{{ claim.NroDePoliza }}</td>
                            <td>{{ claim.VigenciaDesde | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ claim.VigenciaHasta | date: 'MM/dd/yyyy' }}</td>
                            <td *ngIf="showComapnyName"></td>
                            <td *ngIf="permissionMenu.VerComision == 1" >{{ claim.PorcentajeComision }}%</td>
                            <td *ngIf="permissionMenu.VerComisionAgente == 1" >{{ claim.PorcentajeComisionAgente }}%</td>
                            <td >{{ claim.Estatus }}</td>
                            <td>
                                <button type="button" class="btn pl-1 pr-1" (click)="clickView(claim.IdReclamo, 2)" data-toggle="tooltip" title='{{ "INPUT.VIEW" | translate }}'><i class="fa fa-shield-alt"></i></button>
                                <button *ngIf="_user.role == 2" type="button" class="btn pr-1" (click)="clickDownloadEstatement(loadingModal, claim.IdReclamo)"  data-toggle="tooltip" title='{{ "GENERAL.ACCOUNT_ESTATEMENTS" | translate }}'><i class="fa fa-file-alt"></i></button>
                            </td>
                        </tr>

                        <tr *ngIf="!(listClaimsService.items$ | async)?.length">
                            <td colspan="12">
                                <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="!listClaimsService.items$" class="">
                            <td>
                                <div>
                                    <strong>{{"GENERAL.EMPTY_QUERY" | translate}}</strong>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <!--
            <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
                [isLoading]="isLoading" (paginate)="paginate($event)"></app-paginator>-->
        </div>
    </div>
</div>

<div id="view-insurance" *ngIf="templateView==2">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="font-weight-bolder">
                <i class="fa fa-doc text-mid-dark font-size-h1"></i> {{ "GENERAL.VIEWCLAIM" | translate }}
            </h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <button type="button" (click)="onclickModalUploadRequiredDocument(requiredUploadDocumentModal)" class="btn btn-block btn-success font-uppercase font-weight-bolder"><i class="fa fa-upload"> </i> {{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENTS" | translate }}</button>
                </div>
                <div class="col-md-6 col-sm-12">
                    <button type="button" (click)="clickView(0, 1)" class="btn btn-block btn-default font-uppercase font-weight-bolder text-dark-65"><i class="fa fa-chevron-left"> </i>{{ "INPUT.RETURN_TO_LIST" | translate }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div id="claim-error" class="alert alert-warning round-0 rounded-top font-weight-bolder" [hidden]="!claimHasErrorSubject.hasError">
            {{"QUOTES.ERROR1" | translate}}
        </div>

        <form
        [formGroup]="claimForm"
        (ngSubmit)="submitClaim(loadingModal)"
        >
            <input type="hidden" id="inputIdPoliza" name="inputIdPoliza" formControlName="inputIdPoliza" class="form-control" >
            <input type="hidden" id="inputIdReclamo" name="inputIdReclamo" formControlName="inputIdReclamo" class="form-control" >

            <div class="card-header d-none">
                <div class="card-title">
                    <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
                </div>
            </div>

            <div class="card-body py-0 px-0">
                <div class="row mx-5 mt-5">
                    <div class="col-md-3">
                        <label class="sr -only">{{ "CLAIMS.NUM_CLAIM" | translate }}</label>
                        <div class="input-group">
                            <input readonly type="text" id="inputNroReclamo" name="inputNroReclamo" formControlName="inputNroReclamo" class="form-control" >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="sr -only">{{ "INSURANCE.NUM_POLICY" | translate }}</label>
                        <div class="input-group">
                            <input readonly type="text" id="inputNroPoliza" name="inputNroPoliza" formControlName="inputNroPoliza" class="form-control" >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="sr -only">{{ "INPUT.DATE" | translate }}</label>
                            <div class="input-group">
                                <input class="form-control" id="inputFecha" name="inputFecha" formControlName="inputFecha" placeholder="" ngbDatepicker #d2="ngbDatepicker" autocomplete="false" 
                                readonly>
                                <div class="input-group-append">
                                    <button class="btn btn-primary" (click)="d2.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                            </div>
                
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputFecha']
                            }"
                        ></ng-container>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="sr -only">{{ "INPUT.DATE_OCURENCE" | translate }}</label>
                            <div class="input-group">
                                <input class="form-control" id="inputFechaOcurrencia" name="inputFechaOcurrencia" formControlName="inputFechaOcurrencia" placeholder="" ngbDatepicker #d3="ngbDatepicker" autocomplete="false" 
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputFechaOcurrencia'].invalid }"
                                readonly>
                                <div class="input-group-append">
                                    <button class="btn btn-primary" (click)="d3.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                            </div>
                
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputFechaOcurrencia']
                            }"
                        ></ng-container>
                    </div>

                    <div class="col-md-12"></div>

                    <div class="col-md-3" style="display:none">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "CLAIMS.CAUSE_OF_INTEREST" | translate }}</label>
                            <select  class="form-control" placeholder="" name="inputIdCausa" formControlName="inputIdCausa"
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputIdCausa'].invalid }"  required>
                                <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                <option *ngFor="let item of causareclamo | async" value="{{item.IdCausa}}" >{{item.Causas}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputIdCausa']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "CLAIMS.TYPE_OF_INTEREST" | translate }}</label>
                            <select class="form-control" placeholder="" name="inputIdTipoInteres" formControlName="inputIdTipoInteres"
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputIdTipoInteres'].invalid }"  (change)="changeTipoInteres($event)" required>
                                <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                <option *ngFor="let item of tipointeres | async" value="{{item.IdTipoInteres}}" >{{item.TipoInteres}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputIdTipoInteres']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <div class="col-md-3" >
                        <div class="form-group">
                            <label class="-sr-only">{{ "CLAIMS.REPORTED_BY" | translate }}</label>
                            <input readonly id="inputReportadoPor" class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputReportadoPor" name="inputReportadoPor"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputReportadoPor'].invalid }">
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputReportadoPor']
                            }"
                        ></ng-container>
                    </div>

                    <div class="col-md-3" style="display:none">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "CLAIMS.IS_INSURANCE" | translate }}</label>
                            <select  id="inputIdEsAsegurado" class="form-control" placeholder="" name="inputIdEsAsegurado" formControlName="inputIdEsAsegurado"
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputIdEsAsegurado'].invalid }" required>
                                <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                <option *ngFor="let item of sino | async" value="{{item.IdSiNo}}" >{{item.SiNo}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputIdEsAsegurado']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only"><span id="textTipoInteres" style="text-transform: capitalize!important;"></span> {{ "CLAIMS.INUSE" | translate }}</label>
                            <select id="inputIdEnUso" class="form-control" placeholder="" name="inputIdEnUso" formControlName="inputIdEnUso"
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputIdEnUso'].invalid }" required>
                                <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                <option *ngFor="let item of sino | async" value="{{item.IdSiNo}}" >{{item.SiNo}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputIdEnUso']
                                }"
                            ></ng-container>
                        </div>
                    </div>
                </div>

                

                <div class="separator separator-solid separator-border-2 separator-light"></div>

                <div class="row mx-5 mt-5">
                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "INPUT.EMAIL" | translate }}</label>
                            <input readonly type="email" id="inputEmail" name="inputEmail" formControlName="inputEmail" class="form-control"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputEmail'].invalid }">
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputEmail']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "INPUT.PHONE" | translate }}</label>
                            <input readonly type="text" name="inputTelefono" id="inputTelefono" formControlName="inputTelefono" class="form-control"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputTelefono'].invalid }" [showMaskTyped]="true" prefix="+" mask="0(000) 000-0000">
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputTelefono']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "INPUT.COMPLAINT" | translate }}</label>
                            <input readonly type="text" name="inputQuerella" id="inputQuerella" formControlName="inputQuerella" class="form-control"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputQuerella'].invalid }"  [hiddenInput]="true" mask="0000-00-000-00000">
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputQuerella']
                                }"
                            ></ng-container>
                        </div>
                        
                    </div>

                    <div class="col-md-3">
                        <div class="form-group h90">
                            <label class="-sr-only"><span id="inputIdParentesco" style="text-transform: capitalize!important;"></span> {{ "INPUT.RELATIONSHIP" | translate }}</label>
                            <select  id="inputIdParentesco" class="form-control" placeholder="" name="inputIdParentesco" formControlName="inputIdParentesco"
                                [ngClass]="{ 'is-invalid': claimForm.controls['inputIdParentesco'].invalid }" required>
                                <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                <option *ngFor="let item of parentesco | async" value="{{item.IdParentesco}}" >{{item.Parentesco}}</option>
                            </select>
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido.',
                                control: claimForm.controls['inputIdParentesco']
                                }"
                            ></ng-container>
                        </div>
                    </div>
                </div>

                <div class="separator separator-solid separator-border-2 separator-light"></div>

                <div class="row mx-5 mb-5">
                    <div class="col-md-6 mt-3">
                        <div class="form-group">
                            <label class="-sr-only">{{ "CLAIMS.POLICE_FULLNAME" | translate }}</label>
                            <input readonly id="inputNombreCompletoPolicia" class="form-control" placeholder="" formControlName="inputNombreCompletoPolicia" name="inputNombreCompletoPolicia"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputNombreCompletoPolicia'].invalid }">
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputNombreCompletoPolicia']
                            }"
                        ></ng-container>
                    </div>
                    <div class="col-md-12"></div>

                    <div class="col-md-6 col-sm-12  my-5">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "CLAIMS.ACCIDENT_DESCRIPTION" | translate }}</label>
                            <textarea readonly class="form-control"  name="inputDescripcion" formControlName="inputDescripcion" row="10" style="width: 100%; min-height: 150px;"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputDescripcion'].invalid }"
                            ></textarea>
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputDescripcion']
                            }"
                        ></ng-container>
                    </div>

                    <div class="col-md-6 col-sm-12  my-5">
                        <div class="form-group h90">
                            <label class="-sr-only">{{ "CLAIMS.CLAIM_LOCATION" | translate }}</label>
                            <textarea readonly class="form-control" id="inputUbicacionReclamo" name="inputUbicacionReclamo" formControlName="inputUbicacionReclamo" row="10" style="width: 100%; min-height: 150px;"
                            [ngClass]="{ 'is-invalid': claimForm.controls['inputUbicacionReclamo'].invalid }"
                            ></textarea>
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="formError"
                            [ngTemplateOutletContext]="{
                            validation: 'required',
                            message: 'Campo requerido.',
                            control: claimForm.controls['inputUbicacionReclamo']
                            }"
                        ></ng-container>
                    </div>
                </div>
                
                <div class="separator separator-solid separator-border-2 separator-light"></div>

                <div class="row mx-5 my-5">
                    <!-- div class="col-md-12 text-right">
                        <button type="submit" class="btn btn-primary font-weight-boldest " ><i class="fa fa-save"></i> {{ "INPUT.SAVE" | translate }}</button>
                    </div-->
                </div>
            </div>
        </form>
    </div>
</div>

<div style="display: none;"><a href="javascript:void(0)" id="open-pdf" target="_blank"></a></div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<div class="requiredUploadDocumentModal">
    <span *ngIf="closeResult">
    <pre>{{closeResult}}</pre>
    </span>


        <ng-template #requiredUploadDocumentModal let-c="close" let-d="dismiss">
            <div class="modal-header">
                <h4 class="modal-title font-weight-bolder">{{ "DOCUMENTS.REQUIRED_DOCUMENTS" | translate }}</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-primary mb-5">
                    <i class="fa fa-warning"></i> <strong>{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENTS_LIFE" | translate}}</strong>
                </div>

                <div class="row my-5 align-items-left" *ngIf="hasLoadindRD" >
                    <div class="col-1"><img src="/assets/media/misc/loading.gif" width="25px"></div>
                    <div class="col-11">{{ "DOCUMENTS.UPLOADLOADING" | translate }}</div>
                </div>

                <div class="row mb-4 align-items-center" *ngFor="let item of requiredDocument$ | async">
                    <div class="col-12">
                        <label class="d-block" for="file{{ item.IdTipoDocumento }}">{{ item.NombreDocumento }}</label>
                        <div class="input-group is-invalid">
                            <div class="custom-file">
                              <input type="file" class="custom-file-input" id="file{{ item.IdTipoDocumento }}" name="file{{ item.IdTipoDocumento }}" accept=".pdf" (change)="preUpload($event, item.IdTipoDocumento)" />
                              <label class="custom-file-label" id="custom-file-label-{{ item.IdTipoDocumento }}" for="file{{ item.IdTipoDocumento }}">Buscar archivo...</label>
                            </div>
                            <div class="input-group-append">
                                <button class="btn btn-secondary text-white requiredDocument-upload" *ngIf="!hasLoadindRD"  id="upload-file{{ item.IdTipoDocumento }}" type="button" (click)="onclickUploadRequiredDocument(loadingModal, item.IdTipoDocumento)"><i class="fas fa-cloud-upload-alt AUTH"></i>{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENT" | translate}}</button>
                            </div>
                            <div class="input-group-append" *ngIf="item.Cargado==1">
                                <button class="btn btn-primary" id="download-file{{ item.IdTipoDocumento }}" type="button" (click)="onViewDocument(loadingModal, item.IdTipoDocumento)"><i class="fa fa-eye"></i></button>
                             </div>
                             <div class="input-group-append border-0" *ngIf="item.Cargado==1">
                                <span class="input-group-text border-0 bg-white"><i class="fa fa-check text-success"></i></span>
                             </div>

                          </div>
                          <hr>
                    </div>
                </div>
            </div>

            <div class="modal-body" *ngIf="hasLoadindRD">
                
            </div>

            <div class="modal-footer">
                <button type="submit" class="btn btn-success" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
            </div>
        </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>